export const normalizeExcelHeader = (key: string | null | undefined): string => {
  if (!key) return '';

  return key
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim();
};

export const normalizeExcelCellValue = (value: unknown): string => {
  if (value === null || value === undefined) return '';

  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toUpperCase();
};
